<template>
    <report-section title="" class="chart">
        <template v-slot:content>
            <template v-if="model.reportTemplateType === 24">
                <section-header title="睡眠分期时间"></section-header>
                <sleep-period :model="model"></sleep-period>
                <section-header title="监测数据"></section-header>
                <line-chart title="睡眠血氧趋势" :dataArray="model.bloodOxygenChartDataArray"
                    :timeTickArray="model.timeTickArray">
                </line-chart>
                <line-chart title="睡眠脉率趋势" :dataArray="model.pulseChartDataArray"
                    :timeTickArray="model.timeTickArray">
                </line-chart>
                
                <line-chart title="睡眠呼吸趋势" :dataArray="model.breathChartDataArray"
                    :timeTickArray="model.timeTickArray">
                </line-chart>
                <div style="page-break-after: always"></div>
                <line-area-chart title="睡眠分期趋势" :model="model" :timeTickArray="model.timeTickArray">
                </line-area-chart>
                <line-chart title="睡眠呼吸事件" :dataArray="model.breathEventChartDataArray"
                    :timeTickArray="model.timeTickArray">
                </line-chart>
                <area-chart title="睡眠体动占比" :dataArray="model.moveRateChartDataArray"
                    :timeTickArray="model.timeTickArray">
                </area-chart>

                <area-chart title="睡眠体动幅度" :dataArray="model.moveRangeChartDataArray"
                    :timeTickArray="model.timeTickArray" :sn="model.ringSN"></area-chart>
                <section-header title="评估建议"></section-header>
                <ahi-bar :ahi="model.ahi" :ahiTitle="model.ahiTitle" :degreeArray="model.ahiDegreeArray"></ahi-bar>
                <editor style="z-index: 0" :model="model" @onSaveClick="onEditorSaveClick"></editor>
            </template>
            <template v-else>
                <line-chart title="睡眠血氧趋势" :dataArray="model.bloodOxygenChartDataArray"
                    :timeTickArray="model.timeTickArray"></line-chart>
                <line-chart title="睡眠脉率趋势" :dataArray="model.pulseChartDataArray"
                    :timeTickArray="model.timeTickArray"></line-chart>
                <area-chart title="睡眠体动幅度" :dataArray="model.moveRangeChartDataArray"
                    :timeTickArray="model.timeTickArray" :sn="model.ringSN"></area-chart>
            </template>
        </template>
    </report-section>
</template>

<script>

import ReportSection from "@c/report-detail/single-blood-oxygen-report/common/report-section.vue";
import LineChart from "@c/report-detail/report-compression/compression-chart/compression-line-chart.vue";
import AreaChart from "@c/report-detail/report-compression/compression-chart/compression-area-chart.vue";
import SectionHeader from "@c/report-detail/section-header.vue";
import SleepPeriod from "@c/report-detail/sleep-period/sleep-period.vue";
import LineAreaChart from "@c/report-detail/report-compression/compression-chart/compression-line-area-chart.vue";
import AhiBar from "@c/report-detail/ahi-bar.vue";
import Editor from "@c/report-detail/editor.vue";
import { DateTool } from "@js/date-tool.js";
export default {
    components: {
        ReportSection,
        LineChart,
        AreaChart,
        SectionHeader,
        SleepPeriod,
        LineAreaChart,
        AhiBar,
        Editor,
    },
    props: {
        model: Object,
    },
    methods: {
        onEditorSaveClick(model) {
            this.$emit("onEditorSaveClick", model);
        },
    },
};
</script>

<style lang="scss" scoped>
.chart {
    margin-top: 10px;
    transform: translateZ(0);

    ::v-deep(.sleep-period) {
        padding: rem(10) rem(10);
    }

}
</style>